function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { presetLoader, presetsTypes } from '@wix/fedops-presets';
import { ConsentPolicyAccessor } from '@wix/consent-policy-client-accessor';
import { env } from './env';
import performance from './performance/performance';
import Times from './times/times';
import DataSource from './data-source/data-source';
import sessionManager from './session-manager/session-manager';
import LoadingPhases from './loading-phases/loading-phases';
import { create as createReporter } from './reporter/reporter-factory';
import { DataItems } from './data-items/data-items';
import { phasesConfigValues } from './loading-phases/loading-phases-config';
import { generateGuid, getInteractionMark, getPhaseMark, getPathnameTemplate, extractUrl } from './utils';
import { CookieOverrides } from './cookie-overrides';
import { APP_LOAD_ERROR_FLOW } from './errors/error-flow-type';
import httpMonitoringPreset from './http-monitoring-preset';
import { defer } from './defer';
var BLACKBOX = 'wixPerformanceMeasurements';
var BLACKBOX_ENDPOINT = 'bpm';

var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};
/**
 * Base Logger
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */


var BaseLogger = /*#__PURE__*/function () {
  function BaseLogger(appName, appVersion, reporter, params) {
    var defaultParams = {
      appId: null,
      widgetId: null,
      metasiteId: null,
      sessionId: sessionManager.getSessionId(),
      isServerSide: null,
      disableAutoLoadFinish: false,
      phasesConfig: phasesConfigValues.SEND_ON_START,
      interactionTimeout: null,
      timeoutHook: null,
      startHook: null,
      endHook: null,
      isPersistent: false,
      corrId: generateGuid(),
      presetType: presetsTypes.DEFAULT,
      customParams: {},
      paramsOverrides: {}
    };
    var paramsWithDefaults = Object.assign({}, defaultParams, params);
    this.appName = appName;
    this.appVersion = appVersion;
    this.appId = paramsWithDefaults.appId;
    this.widgetId = paramsWithDefaults.widgetId;
    this.metasiteId = paramsWithDefaults.metasiteId;
    this.corrId = paramsWithDefaults.corrId;
    this.isServerSide = paramsWithDefaults.isServerSide;
    this.params = {
      sessionId: paramsWithDefaults.sessionId
    };
    this.httpMonitoringDataItems = new DataItems(this.sessionId, httpMonitoringPreset);
    this.httpMonitoringReporter = createReporter({
      preset: httpMonitoringPreset
    });
    this._customParams = Object.assign({}, paramsWithDefaults.customParams);
    this.disableAutoLoadFinish = paramsWithDefaults.disableAutoLoadFinish;
    this.phasesConfig = paramsWithDefaults.phasesConfig;
    this._appLoadedCalled = {};
    this._appStartLoadCalled = {};
    this._presetType = paramsWithDefaults.presetType;
    this._preset = presetLoader(this._presetType);
    this._constructorParamsOverrides = paramsWithDefaults.paramsOverrides;
    this._cookiesParamsOverrides = new CookieOverrides();
    this.dataItems = new DataItems(this.sessionId, this._preset);
    this.reporter = reporter || createReporter({
      preset: this._preset
    });
    this._times = new Times(appName);
    this.loadingPhases = new LoadingPhases(appName, this._times);
    this.dataSourceBase = new DataSource();
    this.dataSourceBase.addItem(this.dataItems.appName({
      appName: appName,
      isServerSide: this.isServerSide
    })).addItem(this.dataItems.dataItem({
      corrId: this.corrId,
      is_rollout: false
    })).addItem(this.dataItems.dataItem(paramsWithDefaults.paramsOverrides));

    if (params && params.artifactData) {
      this.dataSourceBase.addItem(this.dataItems.artifact(params.artifactData));
    }

    this._outgoingInteractions = {};
    this._outgoingHttpRequests = {};
    this.interactionTimeout = paramsWithDefaults.interactionTimeout;
    this.timeoutHook = paramsWithDefaults.timeoutHook;
    this.startHook = paramsWithDefaults.startHook;
    this.endHook = paramsWithDefaults.endHook;
    this.isPersistent = paramsWithDefaults.isPersistent;
    this._firstErrorFiredInFlow = {};
    this._platformTenantsPromise = defer();
    this._webVitalsLoadedPromise = defer();
    this._webVitalsFirstInputPromise = defer();

    if (paramsWithDefaults.reportBlackbox) {
      this._handleBlackboxPerformance();
    }

    this._reportWebVitalsWhenAvailable();
  }

  var _proto = BaseLogger.prototype;

  _proto._report = function _report(dataSource, reporterEndpoint, params) {
    return this.reporter.report(dataSource.mergeItems(), reporterEndpoint, params);
  };

  _proto._reportIfNotSSR = function _reportIfNotSSR(dataSource, reporterEndpoint, params) {
    if (!this.isServerSide || this.appName.includes('thunderbolt')) {
      return this._report(dataSource, reporterEndpoint, params);
    }
  };

  _proto._reportHttpMonitoring = function _reportHttpMonitoring(dataSource) {
    return this.httpMonitoringReporter.report(dataSource.mergeItems(), httpMonitoringPreset.endpoint);
  };

  _proto._reportPhases = function _reportPhases(dataSource, reporterEndpoint) {
    return this.reporter.report(dataSource.mergePhasesItems(), reporterEndpoint);
  };

  _proto.getAppName = function getAppName() {
    return this.appName;
  };

  _proto.getAppVersion = function getAppVersion() {
    return this.appVersion;
  };

  _proto.getReporter = function getReporter() {
    return this.reporter;
  };

  _proto.getHttpMonitoringReporter = function getHttpMonitoringReporter() {
    return this.httpMonitoringReporter;
  };

  _proto.getParam = function getParam(paramName) {
    return this.params[paramName];
  };

  _proto._isDisableAutoLoadFinish = function _isDisableAutoLoadFinish() {
    return this.disableAutoLoadFinish;
  };

  _proto.isDisableAutoLoadFinish = function isDisableAutoLoadFinish() {
    return this._isDisableAutoLoadFinish();
  };

  _proto.reportNetworkAnalysis = function reportNetworkAnalysis(_ref) {
    var _this = this;

    var appId = _ref.appId;
    var resources = performance.getResources();
    setTimeout(function () {
      try {
        var resourceDataItem = _this.dataItems.resource();

        var analysis = resourceDataItem.performNetworkAnalysis(resources);

        if (!analysis) {
          return;
        }

        var dataSource = _this.dataSource.addItem(resourceDataItem).addItem(analysis).addItem(_this._getDataItemWithDefaultParamsOverrides({
          appName: appId
        }));

        if (appId) {
          _this._changeAppNameForEvent(dataSource, appId);
        }

        _this._report(dataSource);
      } catch (e) {
        console.error('[fedops] Failed to report resource metrics', e);
      }
    }, 1000);
  };

  _proto._getAppLoadingPhaseMarksForApp = function _getAppLoadingPhaseMarksForApp(_ref2) {
    var appId = _ref2.appId;
    var allMarks = performance.getMarks();
    var appMarks = [];
    allMarks.forEach(function (x) {
      var markData = getPhaseMark(x.name);

      if (markData && markData.appId === appId && !markData.widgetId) {
        var startTime = x.startTime,
            name = x.name;
        var markWithStartTime = Object.assign({}, {
          startTime: startTime,
          name: name
        }, markData);
        appMarks.push(markWithStartTime);
      }
    });
    return appMarks;
  };

  _proto._getTimesOfPhase = function _getTimesOfPhase(_ref3) {
    var _appPhasesMarks$find, _appPhasesMarks$find2;

    var phaseName = _ref3.phaseName,
        appPhasesMarks = _ref3.appPhasesMarks,
        appId = _ref3.appId;
    var startMarkTime = (_appPhasesMarks$find = appPhasesMarks.find(function (mark) {
      return mark.name === "[fedops] phase:" + phaseName + " " + appId + " started";
    })) == null ? void 0 : _appPhasesMarks$find.startTime;
    var finishMarkTime = (_appPhasesMarks$find2 = appPhasesMarks.find(function (mark) {
      return mark.name === "[fedops] phase:" + phaseName + " " + appId + " finished";
    })) == null ? void 0 : _appPhasesMarks$find2.startTime;
    return {
      startMarkTime: startMarkTime,
      finishMarkTime: finishMarkTime
    };
  };

  _proto._getPhaseNamesFromMarks = function _getPhaseNamesFromMarks(marks) {
    return new Set(marks.map(function (mark) {
      return mark.phaseName;
    }));
  };

  _proto.reportAppPhasesNetworkAnalysis = function reportAppPhasesNetworkAnalysis(_ref4) {
    var _this2 = this;

    var appId = _ref4.appId;

    var appPhasesMarks = this._getAppLoadingPhaseMarksForApp({
      appId: appId
    });

    var phaseNames = this._getPhaseNamesFromMarks(appPhasesMarks);

    var resources = performance.getResources();
    var dataSource = this.dataSource;
    var resourceDataItem = this.dataItems.resource();
    dataSource.addItem(resourceDataItem);

    for (var _iterator = _createForOfIteratorHelperLoose(phaseNames), _step; !(_step = _iterator()).done;) {
      var phaseName = _step.value;

      try {
        (function () {
          var _this2$_getTimesOfPha = _this2._getTimesOfPhase({
            phaseName: phaseName,
            appPhasesMarks: appPhasesMarks,
            appId: appId
          }),
              startMarkTime = _this2$_getTimesOfPha.startMarkTime,
              finishMarkTime = _this2$_getTimesOfPha.finishMarkTime;

          var resourcesInPhase = resources.filter(function (resource) {
            return resource.startTime > startMarkTime && resource.startTime + resource.duration < finishMarkTime;
          });
          var analysis = resourceDataItem.performNetworkAnalysis(resourcesInPhase);

          if (analysis) {
            dataSource.addItem(analysis);
          }
        })();
      } catch (e) {
        console.error("[fedops] Failed to report resource metrics for \"" + phaseName + "\" phase", e);
      }
    }

    var dataSourceContainsNetworkAnalysis = function dataSourceContainsNetworkAnalysis(datasource) {
      return datasource.items.find(function (dataItem) {
        return typeof dataItem.data.countXhr !== 'undefined';
      });
    };

    if (dataSourceContainsNetworkAnalysis(dataSource)) {
      this._changeAppNameForEvent(dataSource, appId);

      this._reportPhases(dataSource);
    }
  }
  /**
   * Manual report for widget load start - Should only be used if your widget doesn't have its own .vm / .ejs file
   * Call this method at the earliest point possible when your widget starts loading.
   */
  ;

  _proto.appLoadStarted = function appLoadStarted(_temp) {
    var _ref5 = _temp === void 0 ? {} : _temp,
        appId = _ref5.appId,
        paramsOverrides = _ref5.paramsOverrides;

    if (appId && this._appStartLoadCalled[appId] || !appId && this._appStartLoadCalled[this.appName]) {
      return;
    }

    BaseLogger._markAppLoadStarted(this.appName);

    this._appStartLoadCalled[appId || this.appName] = true;

    this._times.setLoadStarted({
      appId: appId
    });

    var dataSource = this.dataSource.addItem(this.dataItems.biAppLoadStart()).addItem(this.dataItems.appContext({
      appId: appId || this.appId,
      widgetId: this.widgetId,
      isServerSide: this.isServerSide
    })).addItem(this._getDataItemWithDefaultParamsOverrides({
      appName: appId
    })).addItem(this.dataItems.dataItem(paramsOverrides));

    if (appId) {
      this._changeAppNameForEvent(dataSource, appId);
    }

    return this._report(dataSource, this._getEndpoint());
  };

  _proto.httpRequest = function httpRequest(_ref6) {
    var artifactId = _ref6.artifactId,
        method = _ref6.method,
        url = _ref6.url;

    var urlTemplate = this._getUrlTemplate(url);

    this._outgoingHttpRequests[urlTemplate] = {
      timestamp: performance.now()
    };
    var dataSource = this.dataSource.addItem(this.httpMonitoringDataItems.biHttpRequest()).addItem({
      artifactId: artifactId,
      method: method,
      url: urlTemplate
    });

    this._reportHttpMonitoring(dataSource);
  };

  _proto.httpResponse = function httpResponse(_ref7) {
    var artifactId = _ref7.artifactId,
        method = _ref7.method,
        statusCode = _ref7.statusCode,
        url = _ref7.url;

    var urlTemplate = this._getUrlTemplate(url);

    if (!this._outgoingHttpRequests[urlTemplate]) {
      throw new Error('To use httpResponse you must use httpRequest first');
    }

    var startTime = this._outgoingHttpRequests[urlTemplate].timestamp;
    var endTime = performance.now();
    var responseTime = Math.floor(endTime - startTime);
    var dataSource = this.dataSource.addItem(this.httpMonitoringDataItems.biHttpResponse()).addItem({
      artifactId: artifactId,
      method: method,
      responseTime: responseTime,
      status_code: statusCode,
      url: urlTemplate
    });

    this._httpResponseTime({
      artifactId: artifactId,
      method: method,
      responseTime: responseTime,
      url: urlTemplate
    });

    this._reportHttpMonitoring(dataSource);
  };

  _proto._httpResponseTime = function _httpResponseTime(_ref8) {
    var artifactId = _ref8.artifactId,
        method = _ref8.method,
        responseTime = _ref8.responseTime,
        url = _ref8.url;
    var dataSource = this.dataSource.addItem(this.httpMonitoringDataItems.biHttpResponseTime()).addItem({
      artifactId: artifactId,
      method: method,
      responseTime: responseTime,
      url: url
    });
    return this._reportHttpMonitoring(dataSource);
  };

  _proto._getUrlTemplate = function _getUrlTemplate(url) {
    var _extractUrl = extractUrl(url),
        origin = _extractUrl.origin,
        pathname = _extractUrl.pathname;

    var convertedPathname = pathname.split('/').filter(function (p) {
      return !!p;
    }).map(function (p) {
      return getPathnameTemplate(p);
    }).join('/');
    return origin + "/" + convertedPathname;
  };

  _proto._shouldAddCustomParams = function _shouldAddCustomParams(customParams) {
    var isEmptyObject = function isEmptyObject(obj) {
      return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    var bothCustomParamsAreEmpty = isEmptyObject(this._customParams) && isEmptyObject(customParams);
    var consentPolicyAccessor = new ConsentPolicyAccessor();

    var _consentPolicyAccesso = consentPolicyAccessor.getCurrentConsentPolicy(),
        functional = _consentPolicyAccesso.functional,
        analytics = _consentPolicyAccesso.analytics;

    var consentAllowsCustomParams = functional && analytics;
    return !bothCustomParamsAreEmpty && consentAllowsCustomParams;
  };

  _proto._addCustomParamsToEvent = function _addCustomParamsToEvent(dataSource, customParams) {
    var customParamsObj = typeof customParams === 'string' ? JSON.parse(customParams) : customParams;
    customParams = Object.assign({}, this._customParams, customParamsObj);

    if (Object.keys(customParams).length > 0) {
      var stringifiedCustomParams = JSON.stringify(customParams);
      dataSource.addItem(this.dataItems.customParams(stringifiedCustomParams));
    }
  }
  /**
   * Final phase. Call this method when your application finishes loading and after all custom phases.
   */
  ;

  _proto.appLoaded = function appLoaded(_temp2) {
    var _ref9 = _temp2 === void 0 ? {} : _temp2,
        appId = _ref9.appId,
        customParams = _ref9.customParams,
        paramsOverrides = _ref9.paramsOverrides;

    if (appId && this._appLoadedCalled[appId] || !appId && this._appLoadedCalled[this.appName]) {
      return;
    }

    BaseLogger._clearLoadTimeout();

    BaseLogger._markAndMeasureAppLoad(this.appName);

    this._appLoadedCalled[appId || this.appName] = true;

    this._sendLastAppLoadPhaseIfNeeded();

    this.reportNetworkAnalysis({
      appId: appId
    });
    var dataSource = this.dataSource.addItem(this.dataItems.biAppLoadFinish()).addItem(this.dataItems.appContext({
      appId: appId || this.appId,
      widgetId: this.widgetId,
      isServerSide: this.isServerSide
    })).addItem(this.dataItems.duration(this._times.getAppLoadTime({
      appId: appId
    })).setFirstRequestDuration(this._times.getFirstRequestDuration())).addItem(this._getDataItemWithDefaultParamsOverrides({
      appName: appId
    })).addItem(this.dataItems.dataItem(paramsOverrides));

    if (appId) {
      this._changeAppNameForEvent(dataSource, appId);
    }

    if (this._shouldAddCustomParams(customParams)) {
      this._addCustomParamsToEvent(dataSource, customParams);
    }

    return this._report(dataSource, this._getEndpoint());
  }
  /**
   * Start of an app loading phase, reports end of previous phase if configured
   */
  ;

  _proto.appLoadingPhaseStart = function appLoadingPhaseStart(name, _temp3) {
    var _ref10 = _temp3 === void 0 ? {} : _temp3,
        appId = _ref10.appId,
        widgetId = _ref10.widgetId,
        paramsOverrides = _ref10.paramsOverrides;

    this.loadingPhases.saveLoadingPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    this._sendPreviousPhaseIfNeeded(name, {
      appId: appId,
      widgetId: widgetId,
      paramsOverrides: paramsOverrides
    });

    performance.mark("[fedops] " + name + " started");
    performance.mark("[fedops] phase:" + name + " " + appId + (widgetId ? " " + widgetId : '') + " started");
    var dataSource = this.dataSource.addItem(this.dataItems.biLoadPhaseStart()).addItem(this.dataItems.appContext({
      appId: appId,
      widgetId: widgetId
    })).addItem(this.dataItems.loadingPhaseStart({
      name: name
    })).addItem(this._getDataItemWithDefaultParamsOverrides({
      appName: appId
    })).addItem(this.dataItems.dataItem(paramsOverrides));

    if (appId) {
      this._changeAppNameForEvent(dataSource, appId);
    }

    this._report(dataSource, this._getEndpoint());
  };

  _proto._changeAppNameForEvent = function _changeAppNameForEvent(dataSource, appName) {
    dataSource.addItem(this.dataItems.appName({
      appName: appName,
      isServerSide: this.isServerSide
    }));
  };

  _proto._sendPreviousPhaseIfNeeded = function _sendPreviousPhaseIfNeeded(name, _temp4) {
    var _ref11 = _temp4 === void 0 ? {} : _temp4,
        appId = _ref11.appId,
        widgetId = _ref11.widgetId,
        paramsOverrides = _ref11.paramsOverrides;

    var previousPhase = this.loadingPhases.getPhasePreviousTo({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (previousPhase && this.phasesConfig === phasesConfigValues.SEND_ON_START) {
      performance.mark("[fedops] " + previousPhase.name + " finished");
      var loadingPhaseDataItem = this.dataItems.loadingPhaseFinish(previousPhase);
      var loadingPhaseBiItem = this.dataItems.biLoadPhaseFinish();
      var overridesDataItem = this.dataItems.dataItem(paramsOverrides);
      var dataSource = this.dataSource.addItem(loadingPhaseDataItem).addItem(loadingPhaseBiItem).addItem(this._getDataItemWithDefaultParamsOverrides({
        appName: appId
      })).addItem(overridesDataItem);

      this._report(dataSource);
    }
  }
  /**
   * End of an app loading phase, reports end of previous phase
   */
  ;

  _proto.appLoadingPhaseFinish = function appLoadingPhaseFinish(name, _temp5) {
    var _ref12 = _temp5 === void 0 ? {} : _temp5,
        appId = _ref12.appId,
        widgetId = _ref12.widgetId,
        widgetArray = _ref12.widgetArray,
        paramsOverrides = _ref12.paramsOverrides;

    if (this.phasesConfig === phasesConfigValues.SEND_ON_START) {
      throw new Error('To use appLoadingPhaseFinish you must use "phasesConfig: SEND_START_AND_FINISH" setting');
    }

    performance.mark("[fedops] " + name + " finished");
    performance.mark("[fedops] phase:" + name + " " + appId + (widgetId ? " " + widgetId : '') + " finished");
    var loadingPhase = this.loadingPhases.getAppLoadingPhaseData({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (!loadingPhase) {
      throw new Error("Cannot report end of a phase that wasn't started. Phase " + name + " doesn't exist");
    }

    var loadingPhaseDataItem = this.dataItems.loadingPhaseFinish(loadingPhase);
    var loadingPhaseBiItem = this.dataItems.biLoadPhaseFinish();

    var defaultParamsOverridesDataItem = this._getDataItemWithDefaultParamsOverrides({
      appName: appId
    });

    var overridesDataItem = this.dataItems.dataItem(paramsOverrides);
    var eventContextDataItem = this.dataItems.appContext({
      appId: appId,
      widgetId: widgetId,
      widgetArray: widgetArray,
      isServerSide: this.isServerSide
    });
    var dataSource = this.dataSource.addItem(loadingPhaseDataItem).addItem(loadingPhaseBiItem).addItem(eventContextDataItem).addItem(defaultParamsOverridesDataItem).addItem(overridesDataItem);

    if (appId) {
      this._changeAppNameForEvent(dataSource, appId);
    }

    return this._report(dataSource, this._getEndpoint());
  };

  _proto._getEndpoint = function _getEndpoint() {
    return this.isPersistent ? this._preset.persistentEndpoint : this._preset.nonPersistentEndpoint;
  };

  _proto._getDataItemWithDefaultParamsOverrides = function _getDataItemWithDefaultParamsOverrides(_temp6) {
    var _ref13 = _temp6 === void 0 ? {} : _temp6,
        _ref13$appName = _ref13.appName,
        appName = _ref13$appName === void 0 ? null : _ref13$appName;

    return this.dataItems.dataItem(_objectSpread(_objectSpread({}, this._cookiesParamsOverrides.getCookieOverridesForApp(appName || this.appName)), this._constructorParamsOverrides));
  } // only for backwards compatibility purposes until we eliminate phasesConfig and SEND_ON_START
  ;

  _proto._sendLastAppLoadPhaseIfNeeded = function _sendLastAppLoadPhaseIfNeeded() {
    var appLoadingPhase = this.loadingPhases.getNextPhaseToReport();
    var shouldReportLastPhase = appLoadingPhase && this.phasesConfig === phasesConfigValues.SEND_ON_START;

    if (shouldReportLastPhase) {
      this._report(this.dataSource.addItem(this.dataItems.loadingPhaseFinish(appLoadingPhase)).addItem(this.dataItems.biLoadPhaseFinish()));
    }
  };

  BaseLogger._clearLoadTimeout = function _clearLoadTimeout() {
    if (env() && env().fedops && typeof env().fedops.clearLoadTimeout === 'function') {
      env().fedops.clearLoadTimeout();
    }
  };

  _proto.clearResourceTimings = function clearResourceTimings() {
    performance.clearResourceTimings();
  };

  BaseLogger._markAppLoadStarted = function _markAppLoadStarted(appName) {
    performance.mark("[fedops] " + appName + " app-load-started");
  };

  BaseLogger._markAndMeasureAppLoad = function _markAndMeasureAppLoad(appName) {
    performance.mark("[fedops] " + appName + " app-loaded");

    try {
      performance.measure("[fedops] " + appName + " app-loaded", "[fedops] " + appName + " app-load-started", "[fedops] " + appName + " app-loaded");
    } catch (e) {}
  };

  _proto._markInteractionStarted = function _markInteractionStarted(interactionName) {
    performance.mark("[fedops] " + this.appName + " interaction " + interactionName + " started");
  };

  _proto._markAndMeasureInteractionEnded = function _markAndMeasureInteractionEnded(interactionName, outgoingInteraction) {
    if (outgoingInteraction) {
      performance.mark("[fedops] " + this.appName + " interaction " + interactionName + " ended");

      try {
        performance.measure("[fedops] " + interactionName + " duration", "[fedops] " + this.appName + " interaction " + interactionName + " started", "[fedops] " + this.appName + " interaction " + interactionName + " ended");
      } catch (e) {}
    }
  }
  /**
   * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/)
   */
  ;

  _proto.interactionStarted = function interactionStarted(interactionName, _temp7) {
    var _this3 = this;

    var _ref14 = _temp7 === void 0 ? {} : _temp7,
        timeOverride = _ref14.timeOverride,
        interactionTimeout = _ref14.interactionTimeout,
        startHook = _ref14.startHook,
        timeoutHook = _ref14.timeoutHook,
        customParams = _ref14.customParams,
        paramsOverrides = _ref14.paramsOverrides;

    this._markInteractionStarted(interactionName);

    var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
      if (interactionTimeout || _this3.interactionTimeout) {
        return setTimeout(function () {
          var dataSource = _this3.dataSource.addItem({
            interactionName: interactionName
          }).addItem({
            errorType: 'timeout'
          }).addItem(_this3.dataItems.biError());

          _this3._reportIfNotSSR(dataSource);

          callHook(timeoutHook || _this3.timeoutHook, {
            name: interactionName,
            timeout: interactionTimeout || _this3.interactionTimeout
          });
        }, interactionTimeout || _this3.interactionTimeout);
      }
    };

    var dataSource = this.dataSource.addItem({
      name: interactionName
    }).addItem(this.dataItems.biInteractionStart()).addItem(this._getDataItemWithDefaultParamsOverrides()).addItem(this.dataItems.dataItem(paramsOverrides));

    if (this._shouldAddCustomParams(customParams)) {
      this._addCustomParamsToEvent(dataSource, customParams);
    }

    this._outgoingInteractions[interactionName] = {
      timestamp: timeOverride ? timeOverride : performance.now(),
      timeout: interactionTimeout || this.interactionTimeout
    };

    this._reportIfNotSSR(dataSource);

    callHook(startHook || this.startHook, {
      name: interactionName
    });
    var timeoutId = scheduleTimeoutEvent();
    return {
      timeoutId: timeoutId
    };
  }
  /**
   * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/)
   */
  ;

  _proto.interactionEnded = function interactionEnded(interactionName, _temp8) {
    var _ref15 = _temp8 === void 0 ? {} : _temp8,
        timeOverride = _ref15.timeOverride,
        timeoutId = _ref15.timeoutId,
        endHook = _ref15.endHook,
        customParams = _ref15.customParams,
        paramsOverrides = _ref15.paramsOverrides;

    var outgoingInteraction = this._outgoingInteractions[interactionName];

    this._markAndMeasureInteractionEnded(interactionName, outgoingInteraction);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    var interaction = this._outgoingInteractions[interactionName] || this._getInteractionFromWindowIfPresent(interactionName);

    var endTime = timeOverride ? timeOverride : performance.now();
    var duration = interaction ? Math.floor(endTime - interaction.timestamp) : '';
    callHook(endHook || this.endHook, {
      name: interactionName,
      duration: duration,
      timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
    });
    var dataSource = this.dataSource.addItem({
      name: interactionName
    }).addItem({
      duration: duration
    }).addItem(this.dataItems.biInteractionEnd()).addItem(this._getDataItemWithDefaultParamsOverrides()).addItem(this.dataItems.dataItem(paramsOverrides));

    if (this._shouldAddCustomParams(customParams)) {
      this._addCustomParamsToEvent(dataSource, customParams);
    }

    delete this._outgoingInteractions[interactionName];

    this._reportIfNotSSR(dataSource);
  };

  _proto._getInteractionsObjectFromWindow = function _getInteractionsObjectFromWindow() {
    var _env, _env$fedops, _env$fedops$apps, _env$fedops$apps$this;

    return ((_env = env()) == null ? void 0 : (_env$fedops = _env.fedops) == null ? void 0 : (_env$fedops$apps = _env$fedops.apps) == null ? void 0 : (_env$fedops$apps$this = _env$fedops$apps[this.appName]) == null ? void 0 : _env$fedops$apps$this.interactions) || {};
  };

  _proto._getInteractionFromWindowIfPresent = function _getInteractionFromWindowIfPresent(interactionName) {
    return this._getInteractionsObjectFromWindow()[interactionName];
  };

  _proto.flush = function flush() {
    this.reporter.flush();
  };

  _proto._handleBlackboxPerformance = function _handleBlackboxPerformance() {
    var _this4 = this;

    var actualEnv = env();
    var wixPerformanceMeasurements = actualEnv[BLACKBOX];

    if (wixPerformanceMeasurements) {
      this._handleBlackboxPerformanceEntries(actualEnv, wixPerformanceMeasurements);
    }

    if (actualEnv.addEventListener) {
      actualEnv.addEventListener(BLACKBOX, function (_ref16) {
        var detail = _ref16.detail;
        return _this4._handleBlackboxPerformanceEntries(actualEnv, detail);
      });
    }
  };

  _proto._handleBlackboxPerformanceEntries = function _handleBlackboxPerformanceEntries(actualEnv, measurements) {
    var _this5 = this;

    measurements.filter(function (_ref17) {
      var then = _ref17.then;
      return then;
    }).forEach(function (performanceEntryPromise) {
      performanceEntryPromise.then(function (performanceEntry) {
        // eslint-disable-next-line default-case
        switch (performanceEntry.entryType) {
          case 'loaded':
            _this5._webVitalsLoadedPromise.resolve(performanceEntry);

            break;

          case 'first-input':
            _this5._webVitalsFirstInputPromise.resolve(performanceEntry);

            break;

          case 'page-transitions':
          case 'crux-cls-s':
          case 'responsiveness':
            if (performanceEntry.eventName && actualEnv.addEventListener) {
              actualEnv.addEventListener(performanceEntry.eventName, function (_ref18) {
                var detail = _ref18.detail;
                return _this5._sendBlackboxMeasurement(detail);
              });
            }

            return;
          // these entries are wrappers for sequences - they themselves are not reported
        }

        _this5._sendBlackboxMeasurement(performanceEntry);
      });
    });
  };

  _proto._sendBlackboxMeasurement = function _sendBlackboxMeasurement(measurement) {
    var blackboxBiDataItem = this.dataItems.biBlackbox(measurement);

    if (blackboxBiDataItem) {
      var blackboxDataItem = this.dataItems.blackboxPerformance(measurement);
      var dataSource = new DataSource().addItem(blackboxBiDataItem).addItem(blackboxDataItem);
      var params;

      if (measurement.entryType === 'loaded') {
        params = {
          useBatch: false
        };
      }

      this._report(dataSource, BLACKBOX_ENDPOINT, params);

      if (measurement.entryType === 'crux') {
        this.flush();
      }
    }
  };

  _proto.getLoggerForWidget = function getLoggerForWidget(_ref19) {
    var appName = _ref19.appName,
        appId = _ref19.appId,
        widgetId = _ref19.widgetId,
        version = _ref19.version,
        timeoutHook = _ref19.timeoutHook,
        startHook = _ref19.startHook,
        endHook = _ref19.endHook,
        useGlobalLogger = _ref19.useGlobalLogger,
        paramsOverrides = _ref19.paramsOverrides,
        phasesConfig = _ref19.phasesConfig;
    var widgetAppName = appName || appId + "_" + widgetId;
    var widgetVersion = version || this.getAppVersion();
    var reporter = useGlobalLogger ? this.reporter : createReporter({
      biLoggerFactory: this.reporter._factory,
      preset: this._preset
    });
    var config = {
      isServerSide: this.isServerSide,
      appId: appId,
      widgetId: widgetId,
      sessionId: this.sessionId,
      phasesConfig: phasesConfig || phasesConfigValues.SEND_ON_START,
      isPersistent: this.isPersistent,
      timeoutHook: timeoutHook,
      startHook: startHook,
      endHook: endHook,
      customParams: this._customParams,
      presetType: this._presetType,
      paramsOverrides: _objectSpread(_objectSpread({}, this._constructorParamsOverrides), paramsOverrides)
    };
    return new BaseLogger(widgetAppName, widgetVersion, reporter, config);
  };

  _proto._getUnReportedErrorFlows = function _getUnReportedErrorFlows(flows) {
    var _this6 = this;

    return flows.filter(function (flow) {
      return !_this6._firstErrorFiredInFlow[flow];
    });
  };

  _proto.reportErrorThrownOncePerFlow = function reportErrorThrownOncePerFlow() {
    var _this7 = this;

    var flows = this._getFlowsOfError();

    var unReportedErrorFlows = this._getUnReportedErrorFlows(flows);

    if (unReportedErrorFlows.length) {
      unReportedErrorFlows.forEach(function (flow) {
        _this7._firstErrorFiredInFlow[flow] = true;

        var dataSource = _this7.dataSource.addItem({
          interactionName: flow
        }).addItem(_this7.dataItems.biError());

        _this7._report(dataSource);
      });
    }
  };

  _proto._errorHappenedInOneOfAppLoadFlows = function _errorHappenedInOneOfAppLoadFlows() {
    return this._errorHappenedInAppLoadFlow() || this._errorHappenedInAppLoadingPhasesFlow();
  };

  _proto._errorHappenedInAppLoadFlow = function _errorHappenedInAppLoadFlow() {
    var appLoadStarted = this._getAppLoadStartedIndication();

    var appLoaded = this._getAppLoadedIndication();

    return appLoadStarted && !appLoaded;
  };

  _proto._getAppLoadStartedIndication = function _getAppLoadStartedIndication() {
    var _performance$getEntri;

    var appLoadStartedMarkName = "[fedops] " + this.appName + " app-load-started";
    var appLoadStartedMark = (_performance$getEntri = performance.getEntriesByName(appLoadStartedMarkName)) == null ? void 0 : _performance$getEntri[0];

    var appLoadStartedTime = this._times.getLoadStartTime();

    return appLoadStartedMark || appLoadStartedTime;
  };

  _proto._getAppLoadedIndication = function _getAppLoadedIndication() {
    var _performance$getEntri2;

    var appLoadedMarkName = "[fedops] " + this.appName + " app-loaded";
    var appLoadedMark = (_performance$getEntri2 = performance.getEntriesByName(appLoadedMarkName)) == null ? void 0 : _performance$getEntri2[0];
    return appLoadedMark || this._appLoadedCalled[this.appName];
  };

  _proto._errorHappenedInAppLoadingPhasesFlow = function _errorHappenedInAppLoadingPhasesFlow(_temp9) {
    var _ref20 = _temp9 === void 0 ? {
      appId: this.appName
    } : _temp9,
        appId = _ref20.appId;

    var appPhasesMarks = this._getAppLoadingPhaseMarksForApp({
      appId: appId
    });

    var phaseNames = this._getPhaseNamesFromMarks(appPhasesMarks);

    for (var _iterator2 = _createForOfIteratorHelperLoose(phaseNames), _step2; !(_step2 = _iterator2()).done;) {
      var phaseName = _step2.value;

      var _this$_getTimesOfPhas = this._getTimesOfPhase({
        phaseName: phaseName,
        appPhasesMarks: appPhasesMarks,
        appId: appId
      }),
          startMarkTime = _this$_getTimesOfPhas.startMarkTime,
          finishMarkTime = _this$_getTimesOfPhas.finishMarkTime;

      if (startMarkTime && !finishMarkTime) {
        return true;
      }
    }

    return false;
  };

  _proto._getFlowsOfError = function _getFlowsOfError() {
    var flowsWithErrors = this._errorHappenedInOneOfAppLoadFlows() ? [APP_LOAD_ERROR_FLOW] : [];
    return [].concat(flowsWithErrors, this._getInteractionNamesWhereErrorHappened());
  };

  _proto._getInteractionNamesWhereErrorHappened = function _getInteractionNamesWhereErrorHappened() {
    var interactionsFromInstance = this._getInteractionNamesWhereErrorHappenedFromInstance();

    if (interactionsFromInstance.length) {
      return interactionsFromInstance;
    }

    var interactionsFromWindow = Object.keys(this._getInteractionsObjectFromWindow());

    if (interactionsFromWindow.length) {
      return interactionsFromWindow;
    }

    return this._getInteractionNamesWhereErrorHappenedFromPerformanceMarks();
  };

  _proto._getInteractionNamesWhereErrorHappenedFromInstance = function _getInteractionNamesWhereErrorHappenedFromInstance() {
    return Object.keys(this._outgoingInteractions);
  };

  _proto._getInteractionNamesWhereErrorHappenedFromPerformanceMarks = function _getInteractionNamesWhereErrorHappenedFromPerformanceMarks() {
    var interactionMarks = this._getInteractionMarksOfCurrentApp();

    return BaseLogger._getInteractionsThatDidntEndFromMarks(interactionMarks);
  };

  _proto._getInteractionMarksOfCurrentApp = function _getInteractionMarksOfCurrentApp() {
    var _this8 = this;

    var allMarks = performance.getMarks();
    return allMarks.reduce(function (interactionMarksOfCurrentApp, mark) {
      var markData = getInteractionMark(mark.name);

      if (markData && markData.appName === _this8.appName) {
        interactionMarksOfCurrentApp[markData.interactionName] = interactionMarksOfCurrentApp[markData.interactionName] || [];
        interactionMarksOfCurrentApp[markData.interactionName].push({
          startTime: mark.startTime,
          name: mark.name
        });
      }

      return interactionMarksOfCurrentApp;
    }, {});
  };

  BaseLogger._getInteractionsThatDidntEndFromMarks = function _getInteractionsThatDidntEndFromMarks(interactionsMarks) {
    var unFinishedInteractions = [];

    for (var interactionName in interactionsMarks) {
      if (interactionsMarks.hasOwnProperty(interactionName)) {
        var _BaseLogger$_countSta = BaseLogger._countStartedEndedInteractionMarks(interactionsMarks[interactionName]),
            startedInteractions = _BaseLogger$_countSta.startedInteractions,
            endedInteractions = _BaseLogger$_countSta.endedInteractions;

        var noInteractionMarks = !startedInteractions && !endedInteractions;
        var moreStartedOrEndedInteractions = startedInteractions - endedInteractions !== 0;

        if (noInteractionMarks || moreStartedOrEndedInteractions) {
          unFinishedInteractions.push(interactionName);
        }
      }
    }

    return unFinishedInteractions;
  };

  BaseLogger._countStartedEndedInteractionMarks = function _countStartedEndedInteractionMarks(interactionsMarks) {
    var startedInteractions = 0;
    var endedInteractions = 0;
    interactionsMarks.forEach(function (mark) {
      if (mark.name.includes('started')) {
        startedInteractions++;
      } else if (mark.name.includes('ended')) {
        endedInteractions++;
      }
    });
    return {
      startedInteractions: startedInteractions,
      endedInteractions: endedInteractions
    };
  };

  _proto.registerPlatformTenants = function registerPlatformTenants(appNames) {
    this._platformTenantsPromise.resolve(appNames);
  };

  _proto._reportWebVitalsWhenAvailable = function _reportWebVitalsWhenAvailable() {
    var _this9 = this;

    Promise.all([this._webVitalsLoadedPromise, this._platformTenantsPromise]).then(function (_ref21) {
      var webVitalsLoaded = _ref21[0],
          platformTenantAppNames = _ref21[1];
      var cls = webVitalsLoaded.cls,
          lcp = webVitalsLoaded.lcp;
      platformTenantAppNames.forEach(function (appName) {
        var dataSource = _this9.dataSource.addItem(_this9.dataItems.webVitalsLoaded()).addItem(_this9.dataItems.appName({
          appName: appName
        })).addItem({
          cls: cls,
          lcp: lcp
        });

        _this9._report(dataSource);
      });
    });
    Promise.all([this._webVitalsFirstInputPromise, this._platformTenantsPromise]).then(function (_ref22) {
      var webVitalsFirstInput = _ref22[0],
          platformTenantAppNames = _ref22[1];
      var delay = webVitalsFirstInput.delay;
      platformTenantAppNames.forEach(function (appName) {
        var dataSource = _this9.dataSource.addItem(_this9.dataItems.webVitalsFirstInput()).addItem(_this9.dataItems.appName({
          appName: appName
        })).addItem({
          fid: delay
        });

        _this9._report(dataSource);
      });
    });
  };

  _createClass(BaseLogger, [{
    key: "dataSource",
    get: function get() {
      return this.dataSourceBase.clone();
    }
  }, {
    key: "sessionId",
    get: function get() {
      return this.getParam('sessionId');
    },
    set: function set(sessionId) {
      this.params['sessionId'] = sessionId;
    }
  }]);

  return BaseLogger;
}();

export { BaseLogger as default };